import { UseControllerProps } from 'react-hook-form'

import { File, Validations } from 'common/interfaces'

export default function fileValidation(validations: Validations): UseControllerProps['rules'] {
  return {
    required: validations.required,
    validate: {
      min: (value) => {
        if (validations.min === undefined) {
          return true
        }

        return (value as File[]).length >= validations.min.value || validations.min.message
      },
      max: (value) => {
        if (validations.max === undefined) {
          return true
        }

        return (value as File[]).length <= validations.max?.value || validations.max?.message
      },
    },
  }
}
